import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useTranslation } from "react-i18next";
import PopupComponent from "@components/PopupComponent";
import TitleComponent from "@components/TitleComponent";
import ButtonComponent from "@components/ButtonComponent";
import { ACCEPTED_FILE_TYPES } from "./constants";

const FileDropModal = ({
  isOpen,
  onClose,
  onProceed,
  currentDataAcquisitionId,
}) => {
  const { t: translate } = useTranslation();
  const [files, setFiles] = useState([]);
  const [refreshFileDrop, setRefreshFileDrop] = useState(false);
  const MIN_FILES_REQUIRED = 1;

  const handleChange = (uploadedFiles) => {
    const filesArray = Array.from(uploadedFiles);
    setFiles((prevFiles) => {
      const existingFileNames = new Set(prevFiles.map((f) => f.name));
      const newFiles = filesArray.filter(
        (file) => !existingFileNames.has(file.name)
      );
      return [...prevFiles, ...newFiles];
    });
  };

  const renderFiles = (filesList) => {
    return (
      <ul className="text-sm overflow-x-hidden list-inside list-disc flex flex-col gap-2 dark:text-primary-400 text-primary-700 mt-2">
        {filesList.map((file) => (
          <li key={file.name} className="gap-2 list-item">
            <span>{file.name}</span>
          </li>
        ))}
      </ul>
    );
  };

  const handleProcceed = () => {
    onProceed(files, () => {
      setFiles([]);
      setRefreshFileDrop(!refreshFileDrop);
    });
  };

  const handleClose = () => {
    setFiles([]);
    onClose();
  };

  return (
    <PopupComponent
      externalClassName={"w-[40vw] !max-w-[550px]"}
      open={isOpen}
      rawValue={
        <>
          <div className="py-5">
            <TitleComponent
              text={translate("data-acquisitions.drop-message")}
              size="lg"
              description={translate("data-acquisitions.drop-description")}
            />
            {!!files.length && renderFiles(files)}
          </div>
          <FileUploader
            key={`fileDrop_${refreshFileDrop}`}
            classes="h-[100px] fileuploader"
            handleChange={handleChange}
            name="file"
            types={ACCEPTED_FILE_TYPES}
            multiple={true}
          />
          <div className="w-full flex justify-end">
            <ButtonComponent
              color="green"
              onClick={handleProcceed}
              text={translate("shared.popup-actions.proceed")}
              className="mt-5"
              disabled={files.length < MIN_FILES_REQUIRED}
            />
          </div>
        </>
      }
      setPopupOpen={handleClose}
      addBlur
      hideCellValue={true}
    />
  );
};

export default FileDropModal;
